// Fonction helper pour envoyer des événements Google Analytics
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// Tracker les page views (pour SPA React)
export const trackPageView = (url, title) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-F4FZJJRNDP', {
      page_path: url,
      page_title: title
    });
  }
};

// Événements prédéfinis
export const trackSimulatorClick = (source = 'unknown') => {
  trackEvent('simulateur_click', {
    event_category: 'Conversion',
    event_label: source,
    value: 1
  });
};

// trackContactSubmit / contact_submit a été remplacé par trackFormSubmit :
// il n'était posé que sur la page de contact, soit un formulaire sur quatre,
// et un second nom d'événement aurait dédoublé la conversion.

/**
 * Envoi de formulaire réussi — l'événement à déclarer comme conversion dans
 * GA4, et à importer ensuite comme action de conversion dans Google Ads.
 *
 * Un seul nom d'événement pour les cinq formulaires, distingués par
 * form_type : GA4 ne compte qu'une conversion par nom d'événement, et on veut
 * pouvoir comparer les formulaires entre eux dans un même rapport.
 *
 * Valeurs de form_type : simulateur, contact, rappel, partenariat,
 * dossier-artisan.
 *
 * Attention : gtag n'existe que si le visiteur a accepté les cookies. Les
 * envois des visiteurs qui refusent ne sont pas comptés — le total GA4 sera
 * toujours inférieur au nombre réel de demandes reçues par e-mail.
 */
export const trackFormSubmit = (formType) => {
  trackEvent('form_submit', {
    form_type: formType,
    event_category: 'Conversion',
    event_label: formType,
    value: 5
  });
};

export const trackPhoneClick = (source = 'unknown') => {
  trackEvent('phone_click', {
    event_category: 'Engagement',
    event_label: source,
    value: 3
  });
};
